import React from 'react';
import { states } from '@/constants/lifecycle';
import UserCards from '@/users/components/UserCards';
import { defaultEvent } from '../helper';
import SubscribersFilters from './SubscribersFilters';
import SubscribersPanelContainer from './SubscribersPanelContainer';
import SubscribersPanelHeader from './SubscribersPanelHeader';
import SubscriptionEventLabel from './SubscriptionEventLabel';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const SubscribersPanelNarrow = ({
  category,
  code,
  onChange,
  url,
}) => {
  const event = defaultEvent(category);
  const state = Selectors.useSubscribersPanelNarrow({ category, code, event });
  const fetchData = Events.useFetchSubscribers(category, { code });

  const handleScroll = () => {
    const page = state.currentPage + 1;
    if (page <= state.pageCount) {
      fetchData({
        event, page, pageSize: state.pageSize, append: true,
      });
    }
  };

  return (
    <SubscribersPanelContainer
      category={category}
      className="aridhia-subscribers-panel-narrow"
      code={code}
      compact
      onChange={onChange}
      url={url}
    >
      <div className="sticky-panel-header">
        {code && (
        <SubscribersPanelHeader
          isLoading={state.readStatus === states.PENDING}
          value={state.name}
          category={category}
          code={code}
        />
        )}
        {event && (<SubscriptionEventLabel event={event} className="dn" />)}
        <SubscribersFilters category={category} className="aridhia-list-filter" code={code} event={event} fluid />
      </div>
      <UserCards
        allowUserLink={state.allowUserLink}
        allowRoleLink={state.allowRoleLink}
        category={category}
        entity="subscriber"
        handleScroll={handleScroll}
        items={state.subscribers}
        itemsPerRow={1}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
      />
    </SubscribersPanelContainer>
  );
};

export default SubscribersPanelNarrow;
